export var DataCatalogDatasetType;
(function (DataCatalogDatasetType) {
    DataCatalogDatasetType["DATA_CATALOG_DATASET_TYPE_TABLE"] = "TABLE";
    DataCatalogDatasetType["DATA_CATALOG_DATASET_TYPE_VIEW"] = "VIEW";
})(DataCatalogDatasetType || (DataCatalogDatasetType = {}));
